export function getCallDurationSeconds(call: {
  duration?: number | string | null;
  call_duration?: string | null;
}): number {
  let durationSeconds =
    typeof call.duration === 'string'
      ? parseInt(call.duration, 10)
      : (call.duration ?? 0);
  if ((!durationSeconds || durationSeconds <= 0) && call.call_duration) {
    const [hours, minutes, seconds] = call.call_duration.split(':').map(Number);
    durationSeconds = hours * 3600 + minutes * 60 + seconds;
  }
  return durationSeconds > 0 && !Number.isNaN(durationSeconds) ? durationSeconds : 0;
}
